module.exports = __webpack_public_path__ + "static/media/level-special.45c34450.png";